import React from "react";

export const ImageUploadFilledIcon = ({
    width = 24,
    height = 24,
    ...props
}) => (
    <svg
        viewBox="0 0 24 24"
        width={width}
        height={height}
        fill="none"
        stroke="currentColor"
        strokeWidth="1"
        strokeLinecap="round"
        strokeLinejoin="round"
        {...props}
    >
        {/* frame */}
        <rect x="3" y="3" width="18" height="18" rx="4" />

        {/* sun */}
        <circle cx="9" cy="9" r="1.5" fill="currentColor" stroke="none" />

        {/* SAME mountain path but closed for fill */}
        <path
            d="M21 15l-5-5-4 4-3-3-6 6v3h18z"
            fill="currentColor"
            stroke="none"
        />

        {/* upload circle */}
        <circle cx="18" cy="18" r="3.5" fill="white" />

        {/* arrow */}
        <path
            d="M18 19.5v-3M16.5 18l1.5-1.5L19.5 18"
            stroke="black"
            strokeWidth="1.5"
        />
    </svg>
);
